import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

interface RestrictedAccessIconProps extends SvgIconProps {
  disabled?: boolean;
  fillColor?: string;
}

const RestrictedAccessIcon = (props: RestrictedAccessIconProps) => {
  const { className, disabled, fillColor, ...otherProps } = props;
  const iconColor = fillColor || (disabled ? 'rgba(255, 255, 255, 0.38)' : 'white');

  return (
    <SvgIcon {...otherProps} className={className || ''} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00004 7.99992C7.28671 7.99992 8.33337 6.95325 8.33337 5.66659C8.33337 4.37992 7.28671 3.33325 6.00004 3.33325C4.71337 3.33325 3.66671 4.37992 3.66671 5.66659C3.66671 6.95325 4.71337 7.99992 6.00004 7.99992ZM6.00004 4.66659C6.55337 4.66659 7.00004 5.11325 7.00004 5.66659C7.00004 6.21992 6.55337 6.66659 6.00004 6.66659C5.44671 6.66659 5.00004 6.21992 5.00004 5.66659C5.00004 5.11325 5.44671 4.66659 6.00004 4.66659ZM6.03337 11.3333H3.18004C3.84004 10.9999 4.98004 10.6666 6.00004 10.6666C6.07337 10.6666 6.15337 10.6733 6.22671 10.6733C6.45337 10.1866 6.84671 9.78659 7.32004 9.46659C6.83337 9.37992 6.37337 9.33325 6.00004 9.33325C4.44004 9.33325 1.33337 10.1133 1.33337 11.6666V12.6666H6.00004V11.6666C6.00004 11.5533 6.01337 11.4399 6.03337 11.3333ZM11 9.66659C9.77337 9.66659 7.33337 10.3399 7.33337 11.6666V12.6666H14.6667V11.6666C14.6667 10.3399 12.2267 9.66659 11 9.66659ZM11.8067 8.45325C12.3134 8.16659 12.6667 7.62659 12.6667 6.99992C12.6667 6.07992 11.92 5.33325 11 5.33325C10.08 5.33325 9.33337 6.07992 9.33337 6.99992C9.33337 7.62659 9.68671 8.16659 10.1934 8.45325C10.4334 8.58659 10.7067 8.66659 11 8.66659C11.2934 8.66659 11.5667 8.58659 11.8067 8.45325Z"
        fill={iconColor}
      />
    </SvgIcon>
  );
};

export default RestrictedAccessIcon;
